import type { ReactNode } from 'react';
import React from 'react';
import classNames from 'classnames';
import type { ModalProps as ModalPropsAntd } from 'antd/lib/modal';
import { Image } from '$components/basic/Image';
import StyledModal from './styled';

export interface ModalProps extends ModalPropsAntd {
  children: ReactNode;
  closeIconSrcLg?: string;
  closeIconSrcSm?: string;
}

/**
 * @deprecated in favor of quantum-components/atoms/Modal/index.tsx
 */
export function Modal({
  wrapClassName,
  children,
  footer = null, // by default don't show confirm buttons
  closeIconSrcLg = '/icons/close_mjptxt.svg',
  closeIconSrcSm = '/icons/close_mjptxt.svg',
  ...props
}: ModalProps): JSX.Element {
  return (
    <StyledModal
      wrapClassName={classNames(
        footer ? 'fixter-deprecated-modal-wrap-with-footer' : 'fixter-deprecated-modal-wrap',
        wrapClassName
      )}
      closeIcon={
        <>
          <Image
            displayTo="md"
            provider="cloudinary"
            src={closeIconSrcSm}
            alt="close"
            layout="fixed"
            width="24"
            height="24"
          />
          <Image
            displayFrom="md"
            provider="cloudinary"
            src={closeIconSrcLg}
            alt="close"
            layout="fixed"
            width="32"
            height="32"
          />
        </>
      }
      title=" "
      centered
      footer={footer}
      {...props}
    >
      {children}
    </StyledModal>
  );
}

Modal.displayName = 'Modal';
